import { useEffect } from "react";

const SITE = "https://antrenordecreier.ro";
const DEFAULT_OG = `${SITE}/brand/og-image.jpg`;

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href, hreflang) {
  if (!href) return;
  const sel = hreflang
    ? `link[rel="${rel}"][hreflang="${hreflang}"]`
    : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Imperative <head> manager (React 19 safe, no duplicate tags).
 * Updates the existing tags from index.html and switches cleanly on language/route change.
 */
export default function Seo({
  title,
  description,
  canonical,
  lang = "ro",
  altRo,
  altEn,
  ogImage = DEFAULT_OG,
  type = "website",
  jsonLd,
}) {
  useEffect(() => {
    document.documentElement.lang = lang;
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:locale", lang === "ro" ? "ro_RO" : "en_US");
    upsertMeta("property", "og:locale:alternate", lang === "ro" ? "en_US" : "ro_RO");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);
    upsertLink("canonical", canonical);
    upsertLink("alternate", altRo, "ro");
    upsertLink("alternate", altEn, "en");
    upsertLink("alternate", altRo, "x-default");

    if (jsonLd) {
      let s = document.getElementById("seo-jsonld");
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "seo-jsonld";
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(jsonLd);
    }

    return () => {
      const s = document.getElementById("seo-jsonld");
      if (s) s.remove();
    };
  }, [title, description, canonical, lang, altRo, altEn, ogImage, type, jsonLd]);

  return null;
}
